import { render, staticRenderFns } from "./SentenciasHistorial.vue?vue&type=template&id=83fa1cb2&scoped=true&"
import script from "./SentenciasHistorial.vue?vue&type=script&lang=js&"
export * from "./SentenciasHistorial.vue?vue&type=script&lang=js&"
import style0 from "./SentenciasHistorial.vue?vue&type=style&index=0&id=83fa1cb2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fa1cb2",
  null
  
)

export default component.exports